import { render } from "./OrderProduction.vue?vue&type=template&id=2449e3b8&scoped=true"
import script from "./OrderProduction.vue?vue&type=script&lang=js"
export * from "./OrderProduction.vue?vue&type=script&lang=js"

import "./OrderProduction.vue?vue&type=style&index=0&id=2449e3b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2449e3b8"

export default script